import { flexRender } from '@tanstack/react-table';
import { Checkbox } from '../../../Inputs';
import { getCellAlign } from '../../cell/align';
import { BodyCell } from '../../components/BodyCell';
import { TableRow } from '../../components/TableRow';
import { useDataProvider } from '../../DataProviderContext';
import { getTableColumnDef } from '../../internal/getTableColumnDef';
import type { TableRow as TRow } from '../../tanstackTypes';

interface RowProps {
  row: TRow<any>;
  isHighlight?: boolean;
  isClickable?: boolean;
  onClick?: (row: TRow<any>) => void;
}

export const Row = ({
  row,
  isClickable = false,
  isHighlight = false,
  onClick,
}: RowProps) => {
  const { table, isRowIndeterminate } = useDataProvider();
  const enableRowSelection = Boolean(table?.options.enableRowSelection);
  const isIndeterminate = isRowIndeterminate?.(row) ?? false;

  return (
    <TableRow
      isClickable={isClickable}
      isHighlight={isHighlight}
      onClick={() => onClick?.(row)}
    >
      {enableRowSelection && (
        <BodyCell padding="checkbox">
          <Checkbox
            name="select-row"
            checked={row.getIsSelected()}
            indeterminate={isIndeterminate}
            onChange={() => row.toggleSelected()}
            onClick={(e) => e.stopPropagation()}
          />
        </BodyCell>
      )}
      {row.getVisibleCells().map((cell) => {
        const columnDef = getTableColumnDef(cell.column);
        const isPlaceholder = cell.getIsPlaceholder?.() ?? false;

        return (
          <BodyCell
            key={cell.id}
            padding={columnDef.cellPadding}
            align={getCellAlign(cell.column)}
          >
            {isPlaceholder
              ? null
              : flexRender(cell.column.columnDef.cell, cell.getContext())}
          </BodyCell>
        );
      })}
    </TableRow>
  );
};
